import { render, staticRenderFns } from "./file.vue?vue&type=template&id=b78f42c6&scoped=true"
import script from "./file.vue?vue&type=script&lang=ts"
export * from "./file.vue?vue&type=script&lang=ts"
import style0 from "./file.vue?vue&type=style&index=0&id=b78f42c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78f42c6",
  null
  
)

export default component.exports